import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./vp7200.css";

function VP3350() {
  const [mainImage, setMainImage] = useState("/images/3350/4-1.png");
  const [activeTab, setActiveTab] = useState("features");

  const thumbnails = [
    "/images/3350/4-2.png",
    "/images/3350/4-3.png",
    "/images/3350/4-4.png",
    "/images/3350/4-5.png",
    "/images/3350/4-6.png"
  ];
  return (
    <>
      <Header />
      <section className="vp7200-container">

        {/* LEFT SIDE */}
        <div className="vp7200-left">
          <div className="main-image">
            <img src={mainImage} alt="VP7200" />
          </div>

          {/* <div className="thumbnails">
            {thumbnails.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                onClick={() => setMainImage(img)}
              />
            ))}
          </div> */}
          <div className="thumbnails">

            {/* TOP ROW (2 IMAGES) */}
            <div className="thumb-row top-row">
              {thumbnails.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

            {/* BOTTOM ROW (3 IMAGES) */}
            <div className="thumb-row bottom-row">
              {thumbnails.slice(3, 5).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="vp7200-right">

          {/* TOP CONTENT */}
          <div className="content-top">
            <h1>VP3350</h1>
            <h3>Robust mobile reader for flexible payment<br />acceptance</h3>

            <p>
              The <b>VP3350</b> is a compact, all-in-one mobile payment reader designed
              to bring secure payment acceptance directly to the point of service.
              Whether at the counter, tableside or on the move, it gives businesses
              the flxibility to take payments wherever their customers are.
            </p>

            <p>
              Available with USB-C, Apple Lightning or Bluetooth connectivity, it
              offers seamless intergration across a wide range of devices and
              applications.
            </p>
          </div>

          {/* TABS */}
          <div className="tabs">
            <button
              className={activeTab === "features" ? "active" : ""}
              onClick={() => setActiveTab("features")}
            >
              KEY FEATURES
            </button>

            <button
              className={activeTab === "specs" ? "active" : ""}
              onClick={() => setActiveTab("specs")}
            >
              SPECIFICATIONS
            </button>
          </div>

          {/* TAB CONTENT */}
          <div className="tab-content">
            {activeTab === "features" && (
              <ul>
                <li>Compact all-in-one mobile payment reader</li>
                <li>Supports chip and contactless payments</li>
                <li>PCI PTS 6.X SRED certified for enhanced security</li>
                <li>Compatible with major card networks and mobile wallets</li>
                <li>Supports Apple VAS and Google SmartTap loyalty programs</li>
                <li>Flexible connectivity via USB-C, Apple Lightning and Bluetooth</li>
                <li>Simple integrations with tablets, smartphones and POS systems</li>
                <li>Field-upgradeable firmware for long-term performance</li>
              </ul>
            )}

            {activeTab === "specs" && (
              <ul>
                <li>Connectivity: USB-C, Ethernet, LTE</li>
                <li>Operating Temp: -30°C to 70°C</li>
                <li>Security: PCI PTS 6.x</li>
                <li>Ingress Protection: IP65</li>
                <li>Dimensions: Compact form factor</li>
              </ul>
            )}
          </div>
        </div>
      </section>
      <section className="vp7200-benefits">

        <div className="vp7200-benefits-container">

          {/* LEFT CONTENT */}
          <div className="benefits-left">
            <h2>Payments that move with your business</h2>

            <p>
              The VP3350 is a compact, secure, and versatile mobile payment reader ideal for modern businesses that need
              flexible payment acceptance. Its small size and multiple connectivity options make it perfect for mobile POS,
              countertop setups, or tablet-based checkout systems, while supporting all major payment types securely.
            </p>

            <ul>
              <li>Multi-Method Payments: Accepts EMV Chip, Contactless/NFC, and traditional magnetic stripe cards.</li>
              <li>Seamless Connectivity: Works with Bluetooth, USB-C, and Apple Lightning for flexible device integration.</li>
              <li>Compact & Portable: Easy to use on the go or integrated into a tablet/POS setup.</li>
              <li>Strong Security: PCI PTS 6.X SRED certified to protect card data and customer transactions.</li>
            </ul>

            {/* PAYMENT METHODS */}
            <h3 className="payment-title">Multiple Payment Methods</h3>

            <div className="payment-logos">
              <img src="/images/7200/gpay.png" alt="GPay" />
              <img src="/images/7200/mc.png" alt="Mastercard" />
              <img src="/images/7200/amex.png" alt="Amex" />
              <img src="/images/7200/visa.png" alt="Visa" />
              <img src="/images/7200/apple.png" alt="Apple Pay" />
              <img src="/images/7200/samsung.png" alt="Samsung Pay" />
              <img src="/images/7200/alipay.png" alt="Alipay" />
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="benefits-right">
            <img
              src="/images/3350/4-7.png"
              alt="Kiosk"
            />
          </div>
        </div>
      </section>
      <section className="vp7200-features">
        <div className="vp7200-features-container">
          <div className="feature-item">
            <img src="/images/7200/flex-connect.png" alt="Connectivity" />
            <h4>Flexible Connectivity</h4>
            <p>Integrate seamlessly into your existing infrastructure.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/secure.png" alt="Security" />
            <h4>Secure & Compliant</h4>
            <p>Protect your business and customers with advanced security.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/rugged.png" alt="Rugged" />
            <h4>Rugged & Reliable</h4>
            <p>Built to withstand tough environments and 24/7 use.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/cust.png" alt="Customer" />
            <h4>Customer Engagement</h4>
            <p>Enhance the payment experience and drive loyalty.</p>
          </div>
        </div>
      </section>
      <section className="vp7200-specs">

        <div className="vp7200-specs-container">

          <h2 className="specs-title">Technical Specifications</h2>

          {/* ELECTRICAL */}
          <div className="spec-group">
            <div className="spec-label">ELECTRICAL</div>

            <div className="spec-content electrical">
              <div className="spec-row">
                <span>BATTERY</span>
                <p>LI-POLYMER BATTERY 400MAH (FOR BT & LIGHTNING MODELS)</p>
              </div>

              <div className="spec-row">
                <span>BATTERY LIFE</span>
                <p>800 MSR TRANSACTIONS<br/>500 CONTACT TRANSACTIONS<br/>400 CONTACTLESS TRANSACTIONS<br/>200 CONTACTLESS + 200 CONTACT + 100 MSR TRANSACTIONS</p>
              </div>

              <div className="spec-row">
                <span>CERTIFICATIONS</span>
                <p>PCI PTS 6.X SRED, EMV CONTACT L1&L2, EMV CONTACTLESS L1<br/>VISA, MASTERCARD, AMEX, DISCOVER, MASTERCARD TQM,<br/>APPLE PAY, GOOGLE PAY, SAMSUNG PAY, FELICA, INTERACT, INTERACT TRANSIT, FCC, CE, ROHS</p>
              </div>

              <div className="spec-row">
                <span>ENCRYPTION</span>
                <p>AES 128, TDES, TRANSARMOR</p>
              </div>

              <div className="spec-row">
                <span>KEY MANAGEMENT</span>
                <p>DUKPT</p>
              </div>
            </div>
          </div>

          {/* ENVIRONMENTAL */}
          <div className="spec-group">
            <div className="spec-label">ENVIRONMENTAL</div>

            <div className="spec-content environmental">

              <div className="spec-row">
                <span>OPERATING ENVIRONMENT</span>
                <p>0°C TO 55°C</p>
              </div>

              <div className="spec-row">
                <span>OPERATING TEMPERATURE</span>
                <p>-20°C TO 55°C</p>
              </div>
            </div>
          </div>

          {/* MECHANICAL */}
          <div className="spec-group">
            <div className="spec-label">MECHANICAL</div>

            <div className="spec-content mechanical">
              <div className="spec-row">
                <span>DIMENSIONS</span>
                <p>67MM (H) X 71MM (W) X 13.5 MM (D)</p>
              </div>

              <div className="spec-row">
                <span>FUNCTIONS</span>
                <p>CONTACTLESS CARD READER<br/>EMV CHIP CARD READER<br/>FIELD UPGRADEABLE FIRMWARE<br/>PASS-THROUGH CHARGING<br/>SMART MSR (READS UP TO 3 TRACKS)</p>
              </div>

              <div className="spec-row">
                <span>INTERFACE</span>
                <p>BLUETOOTH/WIFI, ETHERNET, RS232, USB-C, LTE 4G CAT1</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default VP3350;